import { useCallback, useContext } from 'react'
import { AppStateContext } from './AppStateContext'

interface UserResult {
  saveUserName: (userName: string | undefined) => void
  removeUserName: () => void
}

export const useUserName: () => UserResult = () => {
  const { setUserNameInStore, removeUserNameFromStore } = useContext(AppStateContext)
  const saveUserName = useCallback((userName: string | undefined) => setUserNameInStore(userName), [setUserNameInStore])

  const removeUserName = useCallback(() => removeUserNameFromStore(), [removeUserNameFromStore])

  return {
    saveUserName,
    removeUserName,
  }
}
